/**
 * An ad ID in a playlist is a composite ID of ad server ID and creative ID, separated by `::`.
 * This helper splits the ad ID into its components.
 */
export const splitPlaylistAdId = (
    playlistAdId: string
): { adServerId: string; isBuiltIn: boolean; creativeId: string } | undefined => {
    const separatorIndex = playlistAdId.indexOf('::')
    if (separatorIndex === -1) {
        return undefined
    }

    const adServerId = playlistAdId.substring(0, separatorIndex)
    const creativeId = playlistAdId.substring(separatorIndex + 2)
    const isBuiltIn = adServerId === 'edge-built-in'

    return {
        adServerId,
        isBuiltIn,
        creativeId,
    }
}
